import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';
import { CommunicationTypes, COMMUNICATION_TYPE_AUTO_EMAIL, COMMUNICATION_TYPE_AUTO_SMS } from './OrganisationOverdueBillCommunicationType.js';

export const RECIPIENT_TYPE_ADMIN = 'admin';
export const RECIPIENT_TYPE_USER = 'user';
export const RECIPIENT_TYPE_ORGANISATION = 'organisation';
export const RECIPIENT_TYPE_BILLING_EMAIL = 'billingEmail';
export const RECIPIENT_TYPE_ORG_PHONE = 'organisationPhone';
export const RECIPIENT_TYPE_SUPPORT = 'supportDativery';
export const RECIPIENT_TYPE_CONSULTANT_EMAIL = 'consultantEmail';
export const RECIPIENT_TYPE_CONSULTANT_PHONE = 'consultantPhone';
export const RECIPIENT_TYPE_OWNER_EMAIL = 'ownerEmail';
export const RECIPIENT_TYPE_MANAGER_EMAIL = 'managerEmail';


export const CommunicationTypesForActions = Object.values(CommunicationTypes).filter(type => type.forAction === true);
export const RecipientTypes = {
	[RECIPIENT_TYPE_ADMIN]: {
		allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL, COMMUNICATION_TYPE_AUTO_SMS]
	},
	[RECIPIENT_TYPE_USER]: {
		allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL, COMMUNICATION_TYPE_AUTO_SMS]
	},
	[RECIPIENT_TYPE_ORGANISATION]: {
		allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL, COMMUNICATION_TYPE_AUTO_SMS]
	},
    [RECIPIENT_TYPE_BILLING_EMAIL]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL]
    },
    [RECIPIENT_TYPE_ORG_PHONE]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_SMS]
    },
    [RECIPIENT_TYPE_SUPPORT]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL, COMMUNICATION_TYPE_AUTO_SMS]
    },
    [RECIPIENT_TYPE_CONSULTANT_EMAIL]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL]
    },
    [RECIPIENT_TYPE_CONSULTANT_PHONE]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_SMS]
    },
    [RECIPIENT_TYPE_OWNER_EMAIL]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL]
    },
    [RECIPIENT_TYPE_MANAGER_EMAIL]: {
        allowedTypes: [COMMUNICATION_TYPE_AUTO_EMAIL]
    },
};

export default declareEntity({
	name: "OrganisationOverdueBillAction",
	entity: "organisationOverdueBillActions",
	graphQL: "OrganisationOverdueBillAction",
	dynamoPrefix: 'org',
	storageType: 'central',
	defaultTitle: (data) => data['message'] || "",
	fields: (types) => ({
		id: {
			type: "id",
			defaultValue: () => uuidv4(),
			primaryKey: true,
			required: true,
			userEditable: false,
		},
		name: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Name of the action"
		},
		timestamp: {
			type: "datetime",
			required: false,
			defaultValue: () => new Date(),
			userEditable: false,
			description: "Timestamp of the communication"
		},
		message: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Message content"
		},
		messageEn: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Message content (English)"
		},
		subject: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Subject of the message"
		},
		subjectEn: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Subject (English)"
		},
		recipient: {
			type: "string",
			required: false,
			userEditable: true,
			description: "Recipient of the message"
		},
		type: {
			type: "enum",
			values: CommunicationTypesForActions,
			required: false,
			userEditable: true,
			description: "Type of communication (e.g. 'email', 'notification', 'sms')"
		},
		organisationOverdueBillLog: {
			type: "relation",
			to: () => types["organisationOverdueBillLogs"],
			required: false,
			userEditable: false,
			description: "ID of the associated organisation overdue bill log"
		},
        recipientType: { // backward compatibility; prefer recipientTypes
            type: "enum",
            values: RecipientTypes,
            required: false,
            userEditable: true,
            description: "Deprecated: single recipient type"
        },
        recipientTypes: {
            type: "object",
            required: false,
            userEditable: true,
            description: "Array of recipient type keys",
            defaultValue: [],
        },
		dateTime: {
			type: "datetime",
			required: false,
			defaultValue: () => new Date(),
			userEditable: false,
		},
		createdAt: {
			type: "datetime",
			defaultValue: () => new Date(),
			userEditable: false,
		},
		// --- Rule management fields (policy) ---
		isRule: {
			type: "boolean",
			defaultValue: false,
			userEditable: true,
			description: "If true, this action acts as a rule (policy)"
		},
		enabled: {
			type: "boolean",
			defaultValue: true,
			userEditable: true,
			description: "Rule enabled/disabled"
		},
		groupSend: {
			type: "boolean",
			defaultValue: true,
			userEditable: true,
			description: "Group send per organisation (for rules)"
		},
		scope: {
			type: "enum",
			values: {
				instance: { name: 'Instance-scope' },
				organisation: { name: 'Organisation-scope' }
			},
			defaultValue: 'instance',
			userEditable: true,
			description: "Where the rule applies"
		},
		instance: {
			name: "Instance",
			type: "relation",
			to: () => types['instances'],
			required: false,
			userEditable: false,
			hiddenCreate: true,
			description: "Instance for which this rule applies (if scope=instance)"
		},
		deleted: {
			type: "boolean",
			defaultValue: false,
			userEditable: false,
			description: "Indicates if the action has been deleted"
		},
		flexiTagCode: {
			type: "string",
			required: false,
			userEditable: false,
			description: "Flexi flag code for the action"
		},
		overdueDaysCount: {
			type: "integer",
			required: false,
			userEditable: false,
			description: "Number of days the bill is overdue"
		}
	}),
});


